import { styled } from '@mui/system'
import { ToastContainer } from 'react-toastify'

export const StyledToastContainer = styled(ToastContainer)<{
    themeDefault: any
}>`
    position: fixed;

    .Toastify__toast {
        padding: 0 !important;
        box-shadow: ${({ themeDefault }) =>
            `0 7px 12px 3px ${themeDefault.colors.semantic.sideBarSlider} !important`};
        background-color: ${({ themeDefault }) => {
            return themeDefault.colors.toast.background
        }} !important;
    }

    .Toastify__toast-body {
        padding: 12px !important;
        margin: 0 !important;
        color: var(--text-color-base) !important;
        font-family: var(--font-family-primary);
        font-size: var(--font-size-s);
    }

    .Toastify__close-button {
        padding: 12px;

        & > svg {
            margin-top: 2px;
            height: 14px;
            width: 14px;
        }
    }

    .Toastify__toast-icon {
        margin: 0 12px !important;
        border-right: 1px var(--color-background) solid;
    }

    .Toastify__toast--default {
        background-color: ${({ themeDefault }) => {
            return themeDefault.colors.toast.background
        }};
    }

    .toast {
        background-color: var(--color-black);
    }

    .body {
        .Toastify__toast-theme--light {
            color: inherit !important;
            font-family: var(--font-family-primary);
        }
    }
`

export const ToastBodyWrapper = styled('span')``
export const Circle = styled('span')`
    display: inline-block;
    background-color: #7a7a7a;
    height: 3px;
    width: 3px;
    margin: 2px 6px;
    border-radius: 50%;
`

export const CloseIconWrapper = styled('div')`
    display: flex;
    align-items: center;
    padding: 8px;
    margin: 0;
`
